import { render, staticRenderFns } from "./GMBProfileDashboard.vue?vue&type=template&id=9068e496&scoped=true"
import script from "./GMBProfileDashboard.vue?vue&type=script&lang=js"
export * from "./GMBProfileDashboard.vue?vue&type=script&lang=js"
import style0 from "./GMBProfileDashboard.vue?vue&type=style&index=0&id=9068e496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9068e496",
  null
  
)

export default component.exports